import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: true,
})
export class HighlightPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(parentValue: string, matchValue: string) {
        if (!matchValue) {
            return parentValue;
        }

        // Match in a case-insensitive manner
        const re = new RegExp(matchValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi');
        const match = parentValue.match(re);

        // If there's no match, just return the original value.
        if (!match) {
            return parentValue;
        }

        const replacedValue = parentValue.replace(re, "<span class='highlight'>$&</span>");
        return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
    }
}
